import {
  Separator,
  Row,
  Cell,
  Skeleton,
  useOverlay,
  Subheading,
  H2,
  Paragraph,
  IconButton,
  QuickGlanceOverlay,
} from '@fs/zion-ui'
import { NoticeInfo } from '@fs/zion-icon'
import React from 'react'

import { useGroupData } from '../../hooks'
import transl from './GroupDataHeader.transl'
import InformationPanel from './InformationPanel'

function EditButtonGroupDataHeader() {
  const {
    group: { types, internalFields, imageApids },
    initialGroup: { childGroups, imageApids: initialImageApids },
    itemNumber,
    itemCount,
  } = useGroupData()
  const isVolumeSet = types?.includes('VOLUME_SET')
  const isSplitGroup = Boolean(childGroups?.length > 0)
  const overlay = useOverlay()

  // Calculate tooltip data for the info icon
  const initialLength = initialImageApids?.length
  const firstImage = internalFields?.apid
  const startIndex = React.useMemo(
    () => (firstImage != null ? initialImageApids?.findIndex((apid) => apid === firstImage) || 0 + 1 : null),
    [firstImage, initialImageApids]
  )
  const numberOfImages = imageApids?.length
  const endIndex = startIndex + numberOfImages - 1

  return (
    <>
      {!isVolumeSet && (
        <H2 size="H4" data-heading>
          <Subheading />
        </H2>
      )}
      <Separator size="xs" />
      <Row alignY="middle" gutters="xs">
        <Cell>
          <Paragraph size="sm">
            {isSplitGroup ? transl.subHeading(itemNumber, itemCount) : transl.wholeGroup()}
          </Paragraph>
        </Cell>
        {isSplitGroup && (
          <Cell>
            <IconButton
              Icon={NoticeInfo}
              size="xs"
              color="blue"
              emphasis="low"
              title={transl.tooltipAria()}
              onClick={overlay.handleClick}
            />
          </Cell>
        )}
      </Row>
      <Separator size="xxs" />
      {isSplitGroup && (
        <QuickGlanceOverlay {...overlay} title={transl.tooltipLabel(itemNumber, itemCount)} maxWidth="300px">
          <Paragraph size="sm">{transl.tooltipDescription(itemNumber, startIndex, endIndex, initialLength)}</Paragraph>
        </QuickGlanceOverlay>
      )}
    </>
  )
}

export default function GroupDataHeader({ hideEditButton = true, onEditClick }) {
  const {
    initialGroup: { types },
    loading,
  } = useGroupData()

  if (loading) return <LoadingView />

  const isVolumeSet = types?.includes('VOLUME_SET')
  const showPrevNext = !isVolumeSet
  const showEditButton = !hideEditButton

  return (
    <>
      <EditButtonGroupDataHeader />
      <InformationPanel onEditClick={onEditClick} showPrevNext={showPrevNext} showEditButton={showEditButton} />
    </>
  )
}

function LoadingView() {
  return (
    <>
      <Separator size="xxs" />
      <Row gutters="xxs">
        <Cell growX>
          <Skeleton.H5 subheadingLineCount={1} />
        </Cell>
        <Cell>
          <Skeleton.Button minWidth="70px" />
        </Cell>
      </Row>
      <Separator size="xxs" />
    </>
  )
}
